import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import Icon from '../Icon/Icon';
import Modal from '../Modal/Modal';

/**
 * `ModalOptions` is a lightbox options component, typically for use in cases where you need to preselect an option
 * before displaying eg. a modal.
 *
 * It can also work as a wizard like component using the children as custom content and using css to change if the
 * children components are visible
 *
 * @property {node} children Custom content to be displayed in the options modal, however if you only want custom content
 * then please use the `Modal.
 * @property {string} className The class name of this modal. Will be appended to "core-modal".
 * @property {function} onOptionClick The callback when an option is clicked.
 * @property {array} options List of options for the component, each option should be an object with attributes `name` and
 * `icon`.
 * @property {string} title A title to be displayed in the modal. Defaults to "Select option".
 *
 * @see Modal
 */
export default class ModalOptions extends Component {

  static displayName = 'ModalOptions';

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onOptionClick: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
  };

  static defaultProps = {
    options: [],
    title: 'Select option'
  };

  renderOptions = () => {
    const { options, onOptionClick } = this.props;

    return (
      <ul className="options-list">
        {options.map(option =>
          <li key={option.name} className="option" data-name={option.name} onClick={onOptionClick}>
            <Icon name={option.icon}/>
            <h3 className="option-header">{option.name}</h3>
          </li>
        )}
      </ul>
    );
  };

  render() {
    const { options, className, children, title, onOptionClick, ...rest } = this.props;
    const optionsList = this.renderOptions();
    let cls = 'unnumbered';

    if (options.length <= 4) {
      cls = 'few';
    } else if (options.length <= 6) {
      cls = 'moderate';
    } else if (options.length <= 8) {
      cls = 'many';
    }
    return (
      <div className={cx('modal-options-container modal-options-view', className, cls)}>
        <Modal {...rest} className="centered">
          <div className="modal-options-content">
            <h2 className="modal-header">
              {title}
            </h2>
            {optionsList}
          </div>
          {children}
          <Icon className="close" name="close" onClick={this.props.onClose}/>
        </Modal>
      </div>
    );
  }

}
